<div class="mouse-capture" (click)="dismiss()"></div>
<div class="dialog-container" >
    <div class="dialog-content" #dialogContainer>
        <ng-template  libDialog></ng-template>
    </div>
</div>